import React from 'react';

const NonBookableNotice = () => (
  <div className="padding-10 border-color-grey border-side-all border-style-solid border-radius-4 text-size-10 text-weight-medium text-color-grey margin-bottom-xs-10 margin-bottom-sm-0">
    Reservation Not Available - Pricing Info Only
  </div>
);

export default NonBookableNotice;
